import styled from 'styled-components'

export const Div = styled.div`
  position: fixed;
  right: 2%;
  height: 3.75em;
  width: 3.75em;
  border-radius: 50%;
  background-color: #fff;
  bottom: ${props => (props.signs ? '145px' : '85px')};
  z-index: 1000;
  -webkit-box-shadow: 0 1px 0.375em 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.3);
  -webkit-transition: -webkit-box-shadow 150ms cubic-bezier(0.4, 0, 1, 1);
  transition: -webkit-box-shadow 150ms cubic-bezier(0.4, 0, 1, 1);
  transition: box-shadow 150ms cubic-bezier(0.4, 0, 1, 1);
  transition: box-shadow 150ms cubic-bezier(0.4, 0, 1, 1),
    -webkit-box-shadow 150ms cubic-bezier(0.4, 0, 1, 1);
  transition: box-shadow 150ms cubic-bezier(0.4, 0, 1, 1),
    -webkit-box-shadow 150ms cubic-bezier(0.4, 0, 1, 1);
  opacity: 0.8;
  & img {
    height: 100%;
    width: 100%;
    border-radius: 50%;
  }
`



// WEBPACK FOOTER //
// ./src/components/Elements/StreetViewMap/styles/index.js